export default {
  contentUnavailable: "Embed content not available",
  privacySettings: "Manage privacy settings",
  privacyUrl:
    "https://rivals.mydashboard.oath.com/guc-redirect?app=thirdPartyContentEmbed"
};
